import axios from "axios";
import { useOidcStore } from "vue3-oidc";
import { retryAxiosOnUnauthorized } from "./unauthorizedRetry";
import { blockAxiosInOfflineMode } from "./offlineMode";

const createApiClient = (baseURL) => {
  const client = axios.create({ baseURL });

  client.interceptors.request.use((config) => {
    const { token } = useOidcStore().state.value;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  retryAxiosOnUnauthorized(client);
  blockAxiosInOfflineMode(client);

  return client;
};

export default createApiClient;
